import { AlertSeverityEnum, IEquipoServicioAdicionales, MaterialTransferido } from '@/shared/interfaces';
import { useUiStore } from '@/store/ui';
import { toast } from 'react-toastify';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export enum MaterialesKey2 {
  activeItemRow = 'activeItemRow', // generic key
}

export enum MaterialesKey {
  selectedItems = 'selectedItems', // generic key
  selectedItems2 = 'selectedItems2', // generic key

  productSeries = 'productSeries',
  selectedProductSeries = 'selectedProductSeries',
  savedSelectedProductSeries = 'savedSelectedProductSeries',
  equiposAsignados = 'equiposAsignados',
  equiposUtilizadosFlota = 'equiposUtilizadosFlota',
  materialesDisponibles = 'materialesDisponibles',
  equiposDisponibles = 'equiposDisponibles',
  equiposDisponiblesActivacion = 'equiposDisponiblesActivacion',
  equipoSerieUtilizadaActivacion = 'equipoSerieUtilizadaActivacion',
  equipos_utilizados = 'equipos_utilizados',
  materiales_utilizados = 'materiales_utilizados',
  materialesContratados = 'materialesContratados',
  materialesAdicionales = 'materialesAdicionales',
  otrosMateriales = 'otrosMateriales',
  equiposNuevos = 'equiposNuevos',
  equiposDisponiblesNoMutables = 'equiposDisponiblesNoMutables',
  equiposAdicionalesNotIncluded = 'equiposAdicionalesNotIncluded',
  equiposAdicionalesPreventa = 'equiposAdicionalesPreventa',

  serviciosAdicionalesDigitales = 'serviciosAdicionalesDigitales',
  //
  selectItemsProductoTransferencia = 'selectItemsProductoTransferencia',
  ingresoProductos = 'ingresoProductos',
  equiposAdicionales = 'equiposAdicionales',
  solicitudTransferenciaInventario = 'solicitudTransferenciaInventario',
  //solicitudes-pedidos
  selectedSolicitudesPedidosSeries = 'selectedSolicitudesPedidosSeries',
  solicitudesPedidosSinSeries = 'solicitudesPedidosSinSeries',
  //ordenes compra
  ordenesCompras = 'ordenesCompras',
  //solicitudes pedidos
  solicitudCompras = 'solicitudCompras',
  //compras
  Compras = 'compras',
  revisionDeValoresContabilidad = 'revisionDeValoresContabilidad',

  // Kit
  selectItemKit = 'selectItemKit',
}

type ActiveItemRow = NonNullable<any>;
export interface DynamicTableStore {
  selectedItems: any[];
  selectedItems2: any[];

  activeItemRow: ActiveItemRow;
  setActiveItemRow: (item: ActiveItemRow) => void;

  // OT
  equiposAsignados: any[];
  equiposUtilizadosFlota: any[];
  equipos_utilizados: any[];
  materiales_utilizados: any[];
  materialesContratados: any[];
  materialesDisponibles: any[];
  equiposDisponibles: any[];
  equiposDisponiblesActivacion: any[]; // para activacion - set serie
  equipoSerieUtilizadaActivacion: any[]; // para activacion - set serie
  equiposDisponiblesNoMutables: any[]; // solicitud de transferencia
  productSeries: any[];
  selectedProductSeries: any[];
  savedSelectedProductSeries: any[];
  materialesAdicionales: any[];
  otrosMateriales: any[];
  equiposNuevos: any[];
  equiposAdicionalesNotIncluded: any[];
  equiposAdicionalesPreventa: any[];

  serviciosAdicionalesDigitales: MaterialTransferido[];
  // Movimiento de inventario
  selectItemsProductoTransferencia: MaterialTransferido[];
  ingresoProductos: MaterialTransferido[];
  equiposAdicionales: IEquipoServicioAdicionales[];
  solicitudTransferenciaInventario: MaterialTransferido[];

  // Kit
  selectItemKit: any[]

  //
  selectedSolicitudesPedidosSeries: any[];
  solicitudesPedidosSinSeries: any[];
  //
  ordenesCompras: any[];
  revisionDeValoresContabilidad: any[];
  //
  solicitudCompras: any[];
  //
  compras: any[];

  addSelectedItemCustomKey: (
    item: any,
    key: MaterialesKey,
    idKey?: string,
    incrementCant?: boolean,
    renderAlert?: boolean
  ) => void;
  addSelectedItem: (item: any, key: MaterialesKey) => void;
  addSelectedItemProducto: (
    item: any,
    key: MaterialesKey,
    incrementCant?: boolean
  ) => void;
  updateSelectedItemQuantity: (
    item: any,
    key: MaterialesKey,
    idKey?: string
  ) => void;
  removeSelectedItem: (
    id: string | number,
    key: MaterialesKey,
    idKey?: string
  ) => void;
  clearSelectedItems: (key: MaterialesKey) => void;
  clearAllMaterials: () => void;

  setSelectedItems: (items: any[], key: MaterialesKey) => void;
  //
  addProductoSeriesItem: (item: any, key: MaterialesKey) => void;
  updateQuantityProductoItem: (item: any, key: MaterialesKey) => void;
  updateQuantityProductoItem1: (item: any, key: MaterialesKey) => void;
  updateQuantityRevisionProductoItem: (item: any, key: MaterialesKey) => void;
  updateProductoSeriesItem: (
    item: any,
    series: any,
    key: MaterialesKey
  ) => void;
  removeProductoSeriesItem: (
    id_ubicacion_producto: string,
    key: MaterialesKey
  ) => void;
  clearProductoSeriesItems: () => void;
  addProductoSinSeriesItem: (item: any, key: MaterialesKey, showAlert?:boolean) => void;
  clearProductoSinSeriesItems: () => void;
  //
  addOrdenesComprasProducto: (item: any, key: MaterialesKey, all?: boolean, showAlert?: boolean) => void;
  removeOrdenesComprasProducto: (id: string, key: MaterialesKey) => void;
  clearOrdenesComprasProductos: () => void;
  updateQuantityOrdenesCompras: (item: any, key: MaterialesKey) => void;
  //
  addSolicitudesComprasProducto: (item: any, key: MaterialesKey) => void;
  removeSolicitudesComprasProducto: (id: string, key: MaterialesKey) => void;
  clearSolicitudesComprasProductos: () => void;
  updateQuantitySolicitudesCompras: (item: any, key: MaterialesKey) => void;
  //
  addComprasProducto: (item: any, key: MaterialesKey) => void;
  removeComprasProducto: (id: string, key: MaterialesKey) => void;
  clearComprasProductos: () => void;
  updateQuantityCompras: (item: any, key: MaterialesKey) => void;
  //
  clearSelectedItems2: () => void;

  copyArray: (array: any, key: MaterialesKey) => void;
}

const idsAreEqual = (id1: string | number, id2: string | number) => {
  if (isFinite(Number(id1)) && isFinite(Number(id2))) {
    return Number(id1) === Number(id2);
  }

  return String(id1) === String(id2);
};

const setAlert = useUiStore.getState().setAlert;

export const useMaterialesUtilizadosStore = create<DynamicTableStore>()(
  persist(
    (set, get) => ({

      selectedItems: [],
      selectedItems2: [],
      activeItemRow: null,
      // OT
      equiposAsignados: [],
      equiposUtilizadosFlota: [],
      materialesDisponibles: [],
      equiposDisponibles: [],
      productSeries: [],
      selectedProductSeries: [],
      savedSelectedProductSeries: [],
      equiposDisponiblesNoMutables: [],
      equiposAdicionalesNotIncluded: [],
      equiposAdicionalesPreventa: [],
      equiposDisponiblesActivacion: [],
      equipoSerieUtilizadaActivacion: [],

      serviciosAdicionalesDigitales: [],

      equipos_utilizados: [],
      materiales_utilizados: [],

      materialesContratados: [],
      materialesAdicionales: [],
      otrosMateriales: [],
      equiposNuevos: [],

      //TRANSFERENCIA DE INVENTARIO
      selectItemsProductoTransferencia: [],
      ingresoProductos: [],
      solicitudTransferenciaInventario: [],
      //solicitud de pedido
      selectedSolicitudesPedidosSeries: [],
      solicitudesPedidosSinSeries: [],
      //ordenes de compra
      ordenesCompras: [],
      //solicitud de compra
      solicitudCompras: [],
      //compras
      compras: [],
      revisionDeValoresContabilidad: [],
      //kit
      selectItemKit: [],
      // materiales equipos adicionales
      equiposAdicionales: [],


      addSelectedItem: (item, key, incrementCant = true) => {
        const itemExists = get()[key].some(i => idsAreEqual(i.id, item.id));

        if (itemExists && !incrementCant) {
          setAlert(
            true,
            'Producto se encuentra en la tabla de transferencia',
            'info'
          );
        }
        // just add the item
        if (!itemExists)
          return set(state => ({
            [key]: [...state[key], item],
          }));

        // update the quantity when the item already exists
        set(state => ({
          [key]: state[key].map(i =>
            idsAreEqual(i.id, item.id)
              ? { ...i, cantidad: incrementCant ? i.cantidad + 1 : i.cantidad }
              : i
          ),
        }));
      },

      addSelectedItemCustomKey: (
        item,
        key,
        idKey = 'id',
        incrementCant = false,
        renderAlert = true
      ) => {
        const itemExists = get()[key].some(i =>
          idsAreEqual(i[idKey], item[idKey])
        );
        if (itemExists && !incrementCant && renderAlert) {
          setAlert(
            true,
            'Producto se encuentra en la tabla de transferencia',
            'info'
          );
          return;
        }

        // just add the item
        if (!itemExists) {
          set(state => ({
            [key]: [...state[key], item],
          }));

          renderAlert &&
            setAlert(
              true,
              'Producto agregado correctamente',
              AlertSeverityEnum.success
            );
        }
      },

      addSelectedItemProducto(item, key) {
        const items = get()[key] || [];
        const itemExists = items.some(i => idsAreEqual(i.id, item.id));

        if (itemExists) {
          setAlert(true, 'Producto previamente seleccionado.', AlertSeverityEnum.info);
        }

        // just add the item
        if (!itemExists) {
          toast.success("Producto agregado correctamente");
          return set(state => ({
            [key]: [...(state[key] || []), item],
          }));
        }
        // update the quantity when the item already exists
        set(state => ({
          [key]: (state[key] || []).map(i =>
            idsAreEqual(i.id, item.id) ? { ...i, cantidad: i.cantidad } : i
          ),
        }));
      },

      copyArray: (array, key) => {
        set(_state => ({
          [key]: array ?? [],
        }));
      },

      updateSelectedItemQuantity: (item, key, idKey = 'id') => {
        /* set(state => ({
          [key]: state[key].map(i =>
            idsAreEqual(i[idKey], item[idKey]) ? item : i
          ),
        })); */

        set((state) => {
          // Encontrar el índice del elemento que queremos actualizar
          const index = state[key].findIndex(i => idsAreEqual(i[idKey], item[idKey]));

          // Si no se encuentra el elemento o ya está actualizado, no hacer nada
          if (index === -1 || state[key][index] === item) return {};

          // Crear una nueva lista con el elemento actualizado
          const updatedList = [
            ...state[key].slice(0, index),
            item,
            ...state[key].slice(index + 1),
          ];

          return {
            [key]: updatedList,
          };
        });
      },

      removeSelectedItem: (id, key, idKey = 'id') => {
        set(state => ({
          [key]: state[key].filter(item => !idsAreEqual(item[idKey], id)),
        }));
      },

      clearSelectedItems: key => {
        set({ [key]: [] });
      },

      setSelectedItems: (items, key) => {
        set({ [key]: items ?? [] });
      },

      // setActiveItemRow
      setActiveItemRow: item => {
        set({ activeItemRow: item });
      },
      //add solicitudPedido to material
      addProductoSeriesItem: (item, key) => {
        // Always add the item
        const itemExists = get()[key].some(i => idsAreEqual(i.id, item.id));
        // just add the item
        if (!itemExists) {
          set(state => ({
            [key]: [...state[key], item],
          }));
          setAlert(true, 'Item agregado correctamente', 'success');
        } else {
          setAlert(true, '¡ Este producto ya ha sido seleccionado previamente...!', 'warning');
        }
      },
      updateQuantityProductoItem: (item, key) => {
        set(state => ({
          ...state,
          [key]: state[key].map(i =>
            i.id_ubicacion_producto === item.id_ubicacion_producto ? item : i
            //i.id_producto === item.id_producto? item: i
          ),
        }));
      },
      updateQuantityProductoItem1: (item, key) => {
        set(state => ({
          ...state,
          [key]: state[key].map(i =>
            i.id_producto === item.id_producto ? item : i
          ),
        }))
      },
      updateQuantityRevisionProductoItem: (item, key) => {
        set(state => ({
          ...state,
          [key]: state[key].map(i =>
            i.id === item.id ? item : i
          ),
        }))
      },
      updateProductoSeriesItem: (item, series, key) => {
        set(state => {
          const itemIndex = state[key].findIndex(i =>
            idsAreEqual(i.id, item.id)
          );
          if (itemIndex !== -1) {
            const newItem = { ...state[key][itemIndex], series };
            return {
              [key]: [
                ...state[key].slice(0, itemIndex),
                newItem,
                ...state[key].slice(itemIndex + 1),
              ],
            };
          }
          return state;
        });
      },
      removeProductoSeriesItem: (id_ubicacion_producto, key) => {
        set(state => ({
          ...state,
          [key]: state[key].filter(
            item =>
              !idsAreEqual(item.id_ubicacion_producto, id_ubicacion_producto)
          ),
        }));
      },
      clearProductoSeriesItems: () => {
        set({ selectedSolicitudesPedidosSeries: [] });
      },
      addProductoSinSeriesItem: (item, key, showAlert) => {
        const itemExists = get()[key].some(
          i => JSON.stringify(i) === JSON.stringify(item)
        );
        if (!itemExists) {
          set(state => ({
            [key]: [...state[key], item],
          }));
          if (showAlert !== false) {
            setAlert(true, 'Item agregado correctamente', 'success');
          }
        } else {
          setAlert(true, '¡ Este producto ya ha sido seleccionado previamente...!', 'warning');
        }
      },
      clearProductoSinSeriesItems: () => {
        set({ solicitudesPedidosSinSeries: [] });
      },
      //ordenes de compra
      addOrdenesComprasProducto: (item, key, all = false, showAlert = true) => {

        if (all) {
          set(state => ({
            [key]: [...state[key], ...item],
          }));
          return;
        }

        const itemExists = get()[key].some(
          i => i === item
        );
        if (!itemExists) {
          set(state => ({
            [key]: [...state[key], item],
          }));
          if (showAlert !== false) {
            setAlert(true, 'Item agregado correctamente', 'success');
          }

        } else {
          setAlert(true, 'Ya se encuentra agregado este producto', 'warning');
        }
      },
      removeOrdenesComprasProducto: (id, key) => {
        set(state => ({
          ...state,
          [key]: state[key].filter(item => !idsAreEqual(item.id, id)),
        }));
      },
      clearOrdenesCompraItems: () => {
        set({ ordenesCompras: [] });
      },
      updateQuantityOrdenesCompras: (item, key) => {
        set(state => ({
          ...state,
          [key]: state[key].map(i => (i.id === item.id ? item : i)),
        }));
      },
      clearOrdenesComprasProductos: () => {
        set({ ordenesCompras: [] });
      },
      //solicitud compras
      addSolicitudesComprasProducto: (item, key) => {
        // Always add the item
        const itemExists = get()[key].some(i => idsAreEqual(i.id, item.id));
        // just add the item
        if (!itemExists) {
          set(state => ({
            [key]: [...state[key], item],
          }));
          setAlert(true, 'Item agregado correctamente', 'success');
        } else {
          setAlert(true, 'Ya se encuentra agregado este producto', 'warning');
        }
      },
      removeSolicitudesComprasProducto: (id, key) => {
        set(state => ({
          ...state,
          [key]: state[key].filter(item => !idsAreEqual(item.id, id)),
        }));
      },
      clearSolicitudesComprasProductos: () => {
        set({ solicitudCompras: [] });
      },
      updateQuantitySolicitudesCompras: (item, key) => {
        set(state => ({
          ...state,
          [key]: state[key].map(i => (i.id === item.id ? item : i)),
        }));
      },
      addComprasProducto: (item, key) => {
        // Always add the item
        const itemExists = get()[key].some(i => idsAreEqual(i.id, item.id));
        // just add the item
        if (!itemExists) {
          set(state => ({
            [key]: [...state[key], item],
          }));
          setAlert(true, 'Item agregado correctamente', 'success');
        } else {
          setAlert(true, 'Ya se encuentra agregado este producto', 'warning');
        }
      },
      removeComprasProducto: (id, key) => {
        set(state => ({
          ...state,
          [key]: state[key].filter(item => !idsAreEqual(item.id, id)),
        }));
      },
      clearComprasProductos: () => {
        set({ compras: [] });
      },
      updateQuantityCompras: (item, key) => {
        set(state => ({
          ...state,
          [key]: state[key].map(i => (i.id === item.id ? item : i)),
        }));
      },
      clearSelectedItems2: () => {
        set({ selectedItems2: [] });
      },

      clearAllMaterials: () => {
        set({
          activeItemRow: null,
          savedSelectedProductSeries: [],
          materialesContratados: [],
          selectedItems: [],
          materialesAdicionales: [],
          otrosMateriales: [],
          equiposAsignados: [],
          equiposNuevos: [],
          equipos_utilizados: [],
          materiales_utilizados: [],
          equiposDisponibles: [],
          equiposUtilizadosFlota: [],
          materialesDisponibles: [],
          equiposAdicionalesNotIncluded: [],
          equiposDisponiblesNoMutables: [],
          equiposAdicionalesPreventa: [],
          equiposDisponiblesActivacion: [],
          equipoSerieUtilizadaActivacion: [],

          productSeries: [],
          selectedProductSeries: [],
          selectItemsProductoTransferencia: [],
          ingresoProductos: [],
        });
      },
    }),

    {
      name: 'materiales-utilizados-store',
      version: 1, // Incrementar para forzar migración
      migrate: (persistedState, version) => {
        if (version === 0) {
          const state = persistedState as any;
          // Migrar valores null a arrays vacíos
          return {
            ...state,
            ingresoProductos: state?.ingresoProductos ?? [],
            serviciosAdicionalesDigitales: state?.serviciosAdicionalesDigitales ?? [],
            selectItemsProductoTransferencia: state?.selectItemsProductoTransferencia ?? [],
            equiposAdicionales: state?.equiposAdicionales ?? [],
            solicitudTransferenciaInventario: state?.solicitudTransferenciaInventario ?? [],
          };
        }
        return persistedState as DynamicTableStore;
      },
    }
  )
);
